module.exports = __webpack_public_path__ + "static/media/fish_spell.c942306f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/fish_spell.png
// module id = 307
// module chunks = 0